import React, { createRef, useState } from "react";
import { useRouter } from "next/router";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import { useFormik } from "formik";
import styled from "styled-components";

const API_FORM_URL = "https://ropers.fabien.cool/forms/";
const RECAPTCHA_KEY = "6LfvUPYUAAAAAMMUSMsSsWFo2g6LuOaNytbiRHpf";

const recaptchaRef: any = createRef();

const Select = styled.select`
  border: 1px solid var(--color);
`;

const Input = styled.input`
  border: 1px solid var(--color);
  line-height: 1em;
  padding: 0 1em;
  max-width: 150px;
  height: 30px;
`;

const Textarea = styled.textarea`
  border: 1px solid var(--color);
  padding: 1em;
  grid-column: 1 / span 3;
`;

const Form = styled.form`
  @media (min-width: 767px) {
    display: grid;
    max-width: 600px;
    margin: 0 auto;
    grid-template-rows: 30px 30px 300px;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px 50px;
    padding-bottom: 50px;
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    grid-gap: 20px;
    align-items: center;
    width: 500px;
    max-width: 80vw;
    margin: 0 auto;
    input,
    textarea,
    select {
      max-width: none;
      width: 100%;
    }
  }
`;

const Button = styled.button`
  display: inline-block;
  background: var(--color);
  color: var(--background);
  padding: 0.85em;
  border-radius: 2px;
  margin-bottom: 1em;
  transition: all ease 0.5s;
  text-decoration: none;
  &:hover {
    background: var(--background);
    color: var(--color);
  }
  grid-column: 2 / span 1;
`;

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  message: "",
  eventType: null,
  date: null,
};

export default function ContactForm({ events }) {
  const router = useRouter();
  const [submitted, setSubmitStatus] = useState(false);
  const [loading, setLoadingStatus] = useState(false);

  async function onSubmit(params) {
    try {
      recaptchaRef.current.execute();
      setLoadingStatus(true);
      await axios.get(API_FORM_URL, { params });
      setLoadingStatus(false);
      setSubmitStatus(true);
    } catch (error) {
      console.error(error);
    }
  }

  const { handleChange, handleSubmit, values } = useFormik({
    initialValues,
    onSubmit,
  });

  if (submitted && typeof window !== `undefined`) {
    router.push("/merci");
  }

  return (
    <>
      <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={RECAPTCHA_KEY} />
      <Form onSubmit={handleSubmit}>
        <Input
          id="firstName"
          name="firstName"
          placeholder="Prénom"
          type="text"
          onChange={handleChange}
          value={values.firstName}
        />
        <Input
          id="lastName"
          name="lastName"
          placeholder="Nom"
          type="text"
          onChange={handleChange}
          value={values.lastName}
        />
        <Input
          id="email"
          name="email"
          type="email"
          placeholder="E-mail"
          onChange={handleChange}
          value={values.email}
        />
        <Input
          id="phone"
          name="phone"
          type="phone"
          placeholder="Téléphone"
          onChange={handleChange}
          value={values.phone}
        />
        <Input
          id="date"
          name="date"
          placeholder="Date"
          type="date"
          onChange={handleChange}
          value={values.date}
        />
        <Select
          id="eventType"
          name="eventType"
          onChange={handleChange}
          value={values.eventType}
        >
          <option value="">Nature de l'événement</option>
          {events?.map(({ name, id }) => (
            <option value={id}>{name}</option>
          ))}
        </Select>

        <Textarea
          id="message"
          name="message"
          placeholder="Votre demande"
          onChange={handleChange}
          value={values.message}
        />
        <Button type="submit">Envoyer</Button>
      </Form>
    </>
  );
}
